<template>
  <v-select
    :append-icon="icon"
    box
    :disabled="disabled"
    hide-details
    :items="recurringTypes"
    label="Frequency"
    :rules="rules"
    v-model="frequency"
  ></v-select>
</template>

<script>
import RecurringMixin from '@/mixins/recurring'

export default {
  mixins: [
    RecurringMixin
  ],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'fa-refresh'
    },
    required: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => {
        return [
          (v) => (!!v && v !== 'none') || 'Recurring frequency required'
        ]
      }
    },
    showNone: {
      type: Boolean,
      default: true
    },
    value: String
  },

  computed: {
    recurringTypes () {
      return this.getRecurringTypes()
    },

    frequency: {
      get () {
        return this.value
      },
      set (frequency) {
        this.$emit('input', frequency)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/RecurringFrequencyDropdown.vue